<template>
  <div class="pa-4">
    <v-card class="pa-4">
      <v-toolbar color="success">
        <span class="white--text text-subtitle-1">仿真实训</span>
      </v-toolbar>
      <div class="pa-4">
        <v-data-table :headers="headers" :items="applyList" :sort-by="['currentSort', 'currentSortOrder']"
          :items-per-page="pagination.perPage" :page="pagination.currentPage" :sort-desc="[false, true]" multi-sort
          hide-default-footer no-data-text="暂无申请" class="paginated-table table-striped table-hover">
          <template v-slot:top>
            <v-row justify="space-between">
              <v-col class="d-flex" cols="6" sm="2">
                <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
              </v-col>
              <v-col class="d-flex" cols="6" sm="2">
                <v-text-field v-model="queryParams.name" label="查找" type="search" class="mb-3" clearable
                  style="width: 200px"></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.apply_status="{ item }">{{ item.apply_status | statusMap }}</template>

          <template v-slot:item.option="{ item }">
            <v-btn color="success" @click.stop="openClient">打开客户端</v-btn>
          </template>
        </v-data-table>
      </div>
      <div class="d-flex justify-space-between align-center mt-4">
        <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
        <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
          :per-page="pagination.perPage" :total="pagination.total"> </pagination>
        <v-btn color="success" small >新增</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import { listSimulation, updateSimulation } from '@/api/simulation';

export default {
  name: 'applyComplie',
  filters: {
    statusMap(status) {
      const map = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝',
      }
      return map[status]
    }
  },
  components: { Pagination },
  computed: {
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage
    },
    to() {
      return this.pagination.currentPage * this.pagination.perPage
    },
    total() {
      return this.pagination.total
    }
  },
  data: () => ({
    selectedItem: 1,
    applyList: [],
    headers: [
      { text: '项目名称', align: 'center', value: 'name' },
      { text: '审核状态', align: 'center', value: 'apply_status' },
      { text: '最后修改', align: 'center', value: 'updated_at' },
      { text: '编辑', align: 'center', value: 'option', width: '100px' }
    ],
    currentSort: 'name',
    currentSortOrder: 'asc',
    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 15, 25],
      total: 0
    },
    queryParams: {},
    taskModeMap: {
      study: '学习',
      train: '练习',
      exam: '考核'
    },
  }),
  mounted() {
    this.getList();
  },
  methods: {
    async openClient(item) {
      window.open(`MetaSpaceProject://${JSON.stringify({ projectId: item.project._id })}`)
    },
    getList() {
      const queryParams = Object.assign({}, this.pagination);
      listSimulation(queryParams).then(res => {
        this.applyList = res.data.rows;
        this.pagination.total = res.data.total;
      })
    },
    async handleStatus(status, item) {
      const map = {
        1: '通过',
        2: '拒绝'
      }
      let result = await Swal.fire({
        title: '提示',
        text: `确认 ${map[status] + item.name} 的编译申请？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false
      })

      if (result.value) {
        const data = Object.assign(item, { apply_status: status });
        updateSimulation(data).then(res => {
          this.$store.dispatch('global/showSuccessMsg', '操作成功');
          this.getList()
        })
      }
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false
      })

      if (result.value) {
        this.$store.dispatch('task/removeTask', item)
      }
    }
  }
}
</script>
